/*
 * CUSTOM CART behavior — header bag icon opens the /cart PAGE, not the drawer.
 * ---------------------------------------------------------------------------
 * Desired UX (matches Sarah Flint):
 *   • "Add to cart"      -> slide-out drawer opens   (handled by Dawn product-form.js — untouched)
 *   • Header bag icon    -> navigate to the dedicated /cart page
 *
 * Dawn's cart-drawer.js binds a click listener to #cart-icon-bubble that calls
 * event.preventDefault() and opens the drawer. We intercept the click in the
 * CAPTURE phase at document level (which always runs before the listener Dawn
 * bound on the icon itself) and stopImmediatePropagation, so Dawn's handler
 * never runs and the anchor's native href="/cart" navigation proceeds.
 * No Dawn files edited; loaded site-wide via custom-theme-styles.
 */
(function () {
  function blockDrawerHijack(event) {
    var link = event.target.closest ? event.target.closest('#cart-icon-bubble') : null;
    if (!link) return;
    // Prevent Dawn's drawer-open listener; let the browser follow href to /cart.
    event.stopImmediatePropagation();
  }

  document.addEventListener('click', blockDrawerHijack, true);
  document.addEventListener(
    'keydown',
    function (event) {
      if (event.code === 'Enter' || event.code === 'Space' || event.code === 'NumpadEnter') {
        blockDrawerHijack(event);
      }
    },
    true
  );
})();
